import React, {PureComponent} from "react"
import {MutationProps} from "react-apollo"
import {ApolloQueryResult} from "apollo-boost"
import {DataProxy} from "apollo-cache"
import gql from "graphql-tag"
import sentry from "@irati/utils/services/sentry"
import {Mutation} from "@irati/utils/services/apollo"
import {RecognitionFeedComment, Poll, Recognition} from "@irati/types"
import {getFeedItemQueryByType, getItemType} from "../../helpers/feed"
import {deleteComment} from "../../helpers/comments"

type FeedItem = Poll | Recognition

const graphQLMutation = gql`
  mutation deleteComment($commentId: String!, $comment: RecognitionFeedCommentInput!) {
    deleteComment(commentId: $commentId, comment: $comment)
  }
`

interface Props extends Partial<MutationProps> {
  item: FeedItem,
  comment: RecognitionFeedComment,
  children: any
}

interface Data {
  data: {
    deleteComment: boolean
  }
}

interface CacheResult {
  [name: string]: FeedItem | null
}

export default class DeleteCommentMutation extends PureComponent<Props> {
  render() {
    const {item, comment, children, ...props} = this.props
    return (
      <Mutation mutation={graphQLMutation} {...props}>
        {(mutate: any, apolloState: ApolloQueryResult<Data>) =>
          children(
            () =>
              mutate({
                variables: {
                  commentId: comment.uuid,
                  comment: {
                    id: item.uuid,
                    type: getItemType(item),
                    message: comment.message
                  }
                },
                update: (cache: DataProxy) => {
                  try {
                    const type = getItemType(item)
                    const query = getFeedItemQueryByType(type, item.uuid)

                    if (query) {
                      const result: CacheResult | null = cache.readQuery(query)
                      if (result) {
                        const oldItem = result[type]
                        if (oldItem) {
                          const newItem = deleteComment(oldItem, comment)
                          const data = {[type]: newItem}
                          cache.writeQuery({
                            ...query,
                            data
                          })
                        }
                      }
                    }
                  } catch (e) {
                    sentry.captureException(e)
                  }
                }
              }),
            apolloState
          )
        }
      </Mutation>
    )
  }
}
